<template>
  <div class="document-layout" :class="{ 'bg-white min-h-screen': printing }">
    <div class="text-center pt-3 -mb-3 print-hidden" v-if="!hidePrint">
      <button class="bg-white rounded px-2 py-1 border border-gray-400 hover:bg-indigo-50" @click="print">Print</button>
    </div>
    <div class="invoice-box" :class="{ 'bg-white min-h-screen scale-75': printing }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { ref, nextTick } from 'vue'

export default {
  props: {
    hidePrint: Boolean,
  },
  setup() {
    const printing = ref(false)
    // provide('printing', printing)
    const print = async () => {
      const defaults = {
        background: window.document.body.style.background,
        backgroundColor: window.document.body.style.backgroundColor,
        zoom: window.document.body.style.zoom,
      }
      printing.value = true
      window.$printing = true
      window.document.body.style.background = '#fff'
      window.document.body.style.backgroundColor = '#fff'
      window.document.body.style.zoom = '75%'
      await nextTick()
      await nextTick()
      window.print()
      setTimeout(() => {
        window.document.body.style.background = defaults.background
        window.document.body.style.backgroundColor = defaults.backgroundColor
        window.document.body.style.zoom = defaults.zoom
        printing.value = false
        window.$printing = false
      }, 60)
    }
    return { print, printing }
  },
}
</script>

<style lang="scss">
.document-layout {
  min-height: 100%;
  min-height: 100vh;
  .invoice-box {
    max-width: 960px;
    min-height: 85%;
    min-height: 85%;
    margin: auto;
    margin-top: 25px;
    padding: 30px;
    border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    font-size: 14px;
    line-height: 20px;
    font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
    color: #3a3d4a;
    background-color: white;
  }

  .page-break {
    page-break-before: always !important;
  }

  .invoice-box .table-wrapper {
    border-bottom: 1px solid #eee;
    &.no-border {
      border-bottom: none;
    }
  }

  .invoice-box p.notice {
    width: 100%;
    margin: auto;
    line-height: 150%;
    text-align: left;
    font-size: 75%;
  }

  .invoice-box table {
    width: 100%;
    line-height: inherit;
    text-align: left;
  }

  .invoice-box table td {
    padding: 5px;
    text-anchor: middle;
    vertical-align: middle;
  }

  .invoice-box table td:first-child,
  .invoice-box table tr.heading td {
    white-space: nowrap;
    word-break: keep-all;
  }

  .invoice-box table tr td:nth-child(2),
  .invoice-box table tr td:nth-child(3),
  .invoice-box table tr td:nth-child(4),
  .invoice-box table tr td:nth-child(5) {
    text-align: right;
    padding-left: 5px;
    padding-right: 5px;
  }

  .invoice-box table tr.top table td {
    padding-bottom: 5px;
  }

  .invoice-box table tr.top table td.title {
    font-size: 45px;
    line-height: 45px;
    color: #333;
  }

  .invoice-box table tr.information table td {
    padding-bottom: 40px;
  }

  .invoice-box table tr.heading td {
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-weight: bold;
  }

  .invoice-box table tr td small {
    font-size: 75%;
  }

  .invoice-box table tr.details td {
    padding-bottom: 20px;
  }

  .invoice-box table tr.item td {
    border-bottom: 1px solid #eee;
  }

  .invoice-box table tr.item.last td {
    border-bottom: none;
  }

  .invoice-box table tr.total td:nth-child(3) {
    border-top: 2px solid #ddd;
    margin-top: 5px;
    padding-top: 5px;
    font-weight: bold;
  }

  /** RTL **/
  .rtl {
    direction: rtl;
    font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
  }

  .rtl table {
    text-align: right;
  }

  .rtl table tr td:nth-child(2) {
    text-align: left;
  }

  ul,
  ol {
    font-size: 12px;
    line-height: 18px;
    padding-left: 12px;
    margin: 0;
  }

  ol li ol {
    list-style: upper-latin;
  }

  ul li ul,
  ol li ol {
    padding-left: 14px;
    font-size: 100%;
  }

  ul li ul li,
  ol li ol li {
    padding-top: 0;
    padding-bottom: 0;
  }

  .print-only {
    display: none;
  }

  .invoice-box p.notice {
    margin-top: 5px;
  }

  @media print {
    .invoice-box,
    .document-layout,
    .print-hidden,
    body,
    html {
      background: #fff !important;
      box-shadow: none !important;
      border: none !important;
      width: 100% !important;
    }
    .print-hidden {
      display: none;
    }
    .print-only {
      display: initial;
    }
    @page {
      size: A3 !important;
    }
    ul,
    ol {
      padding-left: 0;
    }
    ul li ul li,
    ol li ol li {
      padding-top: 0;
      padding-bottom: 0;
    }
    .invoice-box {
      max-width: 100%;
      margin: auto;
      padding: 15px;
      border: none;
      box-shadow: none;
      min-height: 100%;
    }
  }

  .price-list {
    thead {
      font-size: 13px;
      line-height: 13px;
    }
    tbody {
      font-size: 12px;
      line-height: 16px;
    }
    tr td {
      border: 1px solid #ddd;
      padding: 2px 10px;
      text-align: right;
      text-anchor: middle;
      vertical-align: middle;
      &:nth-child(1) {
        text-align: left;
        width: 330px;
        overflow-wrap: break-word;
        white-space: break-spaces;
      }
      &:nth-child(2) {
        width: 40px;
      }
      &:last-child {
        width: 110px;
      }
    }
  }
}
</style>
